import { render, staticRenderFns } from "./backxmh.vue?vue&type=template&id=397361fb&scoped=true"
import script from "./backxmh.vue?vue&type=script&lang=js"
export * from "./backxmh.vue?vue&type=script&lang=js"
import style0 from "./backxmh.vue?vue&type=style&index=0&id=397361fb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397361fb",
  null
  
)

export default component.exports